import { createFeatureSelector } from '@ngrx/store';
import { RewardsPreferenceState } from './rewards-preference.reducer';

export const getRewardsPreferenceFeatureState =
  createFeatureSelector<RewardsPreferenceState>('rewardsPreference');
